
export default function ProcessSection() {
  const processSteps = [
    {
      number: "01",
      icon: "ri-phone-line",
      title: "Contacto Inicial",
      description: "Ponte en contacto conmigo para discutir el caso de tu paciente."
    },
    {
      number: "02",
      icon: "ri-file-text-line",
      title: "Evaluación del Caso",
      description: "Analizo el historial médico y las pruebas diagnósticas disponibles."
    },
    {
      number: "03",
      icon: "ri-calendar-line",
      title: "Planificación",
      description: "Diseño el abordaje quirúrgico más adecuado para cada paciente."
    },
    {
      number: "04",
      icon: "ri-truck-line",
      title: "Cirugía Móvil",
      description: "Me desplazo a tu clínica con todo el equipamiento necesario."
    },
    {
      number: "05",
      icon: "ri-heart-pulse-line",
      title: "Seguimiento",
      description: "Acompañamiento completo durante todo el proceso de recuperación."
    }
  ];

  return (
    <section id="proceso" className="py-20 bg-secondary-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-primary-800 mb-6">
            Proceso de Trabajo
          </h2>
          <p className="text-xl text-neutral-600 max-w-3xl mx-auto leading-relaxed">
            Un proceso estructurado y profesional que garantiza los mejores resultados para cada intervención quirúrgica.
          </p>
        </div>

        <div className="relative">
          {/* Línea conectora */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-primary-300 via-accent-300 to-secondary-300"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            {processSteps.map((step, index) => (
              <div key={index} className="relative">
                {/* Número del paso */}
                <div className="relative z-10 w-16 h-16 bg-gradient-to-br from-primary-600 to-accent-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                  <span className="text-white font-bold text-lg">{step.number}</span>
                </div>

                {/* Tarjeta */}
                <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-primary-100">
                  <div className="w-12 h-12 bg-gradient-to-br from-accent-100 to-primary-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <i className={`${step.icon} text-primary-600 text-xl`}></i>
                  </div>
                  <h3 className="text-lg font-display font-bold text-primary-800 mb-3 text-center">
                    {step.title}
                  </h3>
                  <p className="text-neutral-600 text-sm mb-4 leading-relaxed text-center">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <div className="bg-white rounded-xl p-8 shadow-lg border border-primary-100 max-w-4xl mx-auto">
            <h3 className="text-2xl font-display font-bold text-primary-800 mb-4">
              ¿Listo para comenzar?
            </h3>
            <p className="text-neutral-600 mb-6">
              Contacta conmigo para discutir el caso de tu paciente y programar la intervención.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="mailto:vetconejero@gmail.com"
                className="bg-gradient-to-r from-primary-600 to-accent-500 hover:from-primary-700 hover:to-accent-600 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>
                Enviar Email
              </a>
              <a
                href="https://wa.me/34600581975"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-accent-500 to-primary-600 hover:from-accent-600 hover:to-primary-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp
              </a>
              <a
                href="https://instagram.com/vetconejero"
                target="_blank"
                rel="noopener noreferrer"
                className="border-2 border-accent-500 text-accent-600 hover:bg-accent-500 hover:text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-instagram-line mr-2"></i>
                Seguir en Instagram
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}